import React, { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

const CustomAlert = ({ message, type = 'success', onClose, duration = 3000 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    // แสดง alert ด้วย animation
    const showTimer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    // ซ่อน alert อัตโนมัติ
    if (duration > 0) {
      const hideTimer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(() => {
          onClose();
        }, 300); // รอ animation จบก่อนปิด
      }, duration);
      return () => {
        clearTimeout(showTimer);
        clearTimeout(hideTimer);
      };
    }

    return () => clearTimeout(showTimer);
  }, [duration, onClose]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      case 'warning':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      default:
        return '✅';
    }
  };

  const getStyles = () => {
    const baseStyles = {
      position: 'fixed',
      top: '20px',
      right: isVisible ? '20px' : '-400px',
      padding: '16px 20px',
      borderRadius: '12px',
      boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      minWidth: '320px',
      maxWidth: '450px',
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      fontSize: '14px',
      fontWeight: '500',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
    };

    switch (type) {
      case 'success':
        return {
          ...baseStyles,
          backgroundColor: 'rgba(240, 253, 244, 0.95)',
          borderColor: '#bbf7d0',
          color: '#166534',
        };
      case 'error':
        return {
          ...baseStyles,
          backgroundColor: 'rgba(254, 242, 242, 0.95)',
          borderColor: '#fecaca',
          color: '#dc2626',
        };
      case 'warning':
        return {
          ...baseStyles,
          backgroundColor: 'rgba(255, 251, 235, 0.95)',
          borderColor: '#fed7aa',
          color: '#d97706',
        };
      case 'info':
        return {
          ...baseStyles,
          backgroundColor: 'rgba(239, 246, 255, 0.95)',
          borderColor: '#bfdbfe',
          color: '#1d4ed8',
        };
      default:
        return baseStyles;
    }
  };

  const closeButtonStyle = {
    marginLeft: 'auto',
    background: 'none',
    border: 'none',
    fontSize: '20px',
    cursor: 'pointer',
    color: 'inherit',
    opacity: 0.7,
    transition: 'all 0.2s ease',
    padding: '4px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '24px',
    minHeight: '24px',
  };

  const iconStyle = {
    fontSize: '20px',
    flexShrink: 0,
  };

  const messageStyle = {
    flex: 1,
    lineHeight: '1.4',
  };

  return (
    <div style={getStyles()}>
      <span style={iconStyle}>{getIcon()}</span>
      <span style={messageStyle}>{message}</span>
      <button
        onClick={handleClose}
        style={closeButtonStyle}
        onMouseEnter={(e) => {
          e.target.style.opacity = '1';
          e.target.style.backgroundColor = 'rgba(0, 0, 0, 0.1)';
        }}
        onMouseLeave={(e) => {
          e.target.style.opacity = '0.7';
          e.target.style.backgroundColor = 'transparent';
        }}
        title={t('close')}
      >
        ×
      </button>
    </div>
  );
};

export default CustomAlert; 